import { render } from "./MonitorInstructionTitle.vue?vue&type=template&id=1edcfe4c&scoped=true"
import script from "./MonitorInstructionTitle.vue?vue&type=script&lang=js"
export * from "./MonitorInstructionTitle.vue?vue&type=script&lang=js"

import "./MonitorInstructionTitle.vue?vue&type=style&index=0&id=1edcfe4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edcfe4c"]])

export default __exports__